import React from 'react';
import './Footer.css';
import { Button } from './Button';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div className='footer-container'>
      
      <div class='footer-links'>
        <div className='footer-link-wrapper'>
          <div class='footer-link-items'>
            <h2>Services</h2>
            <Link to='/central-heating'>Central Heating</Link>
            <Link to='/domesticHotWater'>Domestic Hot Water</Link>
            <Link to='/pool-heating'>Pool Heating</Link>
            <Link to='/solar-waterHeating'>Solar Heating</Link>
          </div>
          <div class='footer-link-items'>
            <h2>Contact Us</h2>
            <Link to='/'>Phone: 01001787846</Link>
            <Link to='/'>Whatsapp: 01001787846</Link>
            <Link to='/'>Mail: Info@golbalheating.com</Link>
          </div>
        </div>
        <div className='footer-link-wrapper'>
          <div class='footer-link-items'>
            <h2>Social Media</h2>
            <a href='https://instagram.com/global.heatingco/'>
            <text class='fab fa-instagram'> Instagram</text>
            </a>
            <a href='https://www.facebook.com/globalheatig'>
            <text class='fab fa-facebook-f'>  Facebook</text>
            </a>
          </div>
        </div>
      </div>
      <section class='social-media'>
        <div class='social-media-wrap'>
          <div class='footer-logo'>
            <Link to='/' className='social-logo'>
              GLOBAL HEATING
            </Link>
          </div>
          <small class='website-rights'>GLOBAL HEATING © 2022</small>
          {/* <div class='social-icons'>
            <Link
              class='social-icon-link facebook'
              to='/'
              target='_blank'
              aria-label='Facebook'
            >
              <i class='fab fa-facebook-f' />
            </Link>
            <Link
              class='social-icon-link instagram'
              to='/'
              target='_blank'
              aria-label='Instagram'
            >
              <i class='fab fa-instagram' />
            </Link>
          
           
          </div> */}
        </div>
      </section>
    </div>
  );
}

export default Footer;
